export default "__VITE_ASSET__DWnKbiYo__"